import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BagPaymentListAddModalComponent } from './bag-payment-list-add-modal/bag-payment-list-add-modal.component';
import { BagPaymentListService } from '../bag-payment-list.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-bag-payment-list-add',
	templateUrl: './bag-payment-list-add.component.html',
	styleUrls: ['./bag-payment-list-add.component.scss'],
})
export class BagPaymentListAddComponent {
	@Input() bankAccounts: any[];
	@Input() profileData: any[];

	constructor(
		public dialog: MatDialog,
		private readonly _service: BagPaymentListService,
		protected loader: LoaderService,
	) {}

	openDialog(): void {
		const dialogRef = this.dialog.open(BagPaymentListAddModalComponent, {
			height: '70%',
			width: '80%',
			data: {
				bankAccounts: this.bankAccounts,
				profileData: this.profileData,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === 'send') {
				this.loader.show();
				this._service.loadPayments();
			}
		});
	}
}
